import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { deleteSupplementalQuestion } from "~/providers/api";
import { supplementalQuestionsQueryOptionsFactory } from "../factories/supplementalQuestionsQueryOptionsFactory";

export const useDeleteSupplementalQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSupplementalQuestion,
    onError: () =>
      toast.error(
        "There was an issue deleting the question. Please try again later.",
      ),
    onSuccess: () => {
      queryClient
        .invalidateQueries({
          queryKey: supplementalQuestionsQueryOptionsFactory.list._def,
          exact: false,
        })
        .catch(() => {
          toast.error("Failed to refresh questions data.");
        });
    },
  });
};
